import axios from "./httpClient";

import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { throwApiError } from "./apiError";

/**
 * GET API call using Axios
 * @param cancelToken - Token to cancel multiple requests
 * @returns - Array of Terminal List of type string[]
 */

export const exceptionAssign = async (params: any, partial_headers?: any) => {
  try {
    let headers = {
      "Content-Type": "application/json",
      "OSD-Module-Name": "myAssignments",
      "OSD-Section-Name": "dataTable",
      "OSD-Action-Type": "assign",
    };
    if (partial_headers) {
      headers = { ...headers, ...partial_headers };
    }
    const response = await axios.post(getUrl(ApiType.EXCEPTION_ASSIGN), params, { headers });
    return response.data;
  } catch (error: any) {
    return throwApiError(error, ErrorMessages.exceptionAssign, { badRequestOrder: "errorsFirst" });
  }
};
